import { render, staticRenderFns } from "./Detailpage.vue?vue&type=template&id=22f7bbd5&"
import script from "./Detailpage.vue?vue&type=script&lang=js&"
export * from "./Detailpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports